import type { BackendModule } from 'i18next'

// Pre-glob all translation JSON files so Vite includes them in the production build.
// This avoids 404s that occurred because the dynamic import with @vite-ignore prevented bundling.
// Lazy (non-eager) so each language stays code-split.
const translationLoaders: Record<string, () => Promise<unknown>> = import.meta.glob('./translations/*.json')

type Translation = Record<string, unknown>

const loadTranslation = (language: string): Promise<Translation> => {
	const key = `./translations/${language}.json`
	const loader = translationLoaders[key]
	if (!loader) {
		return Promise.reject(new Error(`Missing translation file for language: ${language}`))
	}
	return loader().then((m: unknown) => {
		if (typeof m === 'object' && m !== null && 'default' in m) {
			const mod = m as { default: Translation }
			return mod.default
		}
		return m as Translation
	})
}

const customi18nBackend: BackendModule = {
	type: 'backend',
	init() {},
	read(language, _ns, cb) {
		loadTranslation(language)
			.then((data) => cb(null, data))
			.catch((err) => cb(err as Error, false))
	},
}

export default customi18nBackend
